import { GridModel } from "../grid/grid.model";

export class AskModel {

    constructor() {
        this.sta = 1
        this.grd = new GridModel()
        this.tbls = []
        this.clms = []
    }

    id: string
    host_id: string
    tit: string
    whe: string
    hav: string
    scm: string
    tnam: string

    grd: GridModel
    tbls: TblModel[]
    clms: ClmModel[]

    // --- nodb -----------------------
    sta: number // state => (1).view, 2.edit, 3.new
}

export class TblModel {
    id: string
    ask_id: string
    scm: string
    nam: string
    als: string
    jtyp: number
    jval: string
    srt: number

    dbcols: DbcolModel[]
}

export class DbcolModel {
    table_schema: string
    table_name: string
    column_name: string
    is_nullable: boolean
    data_type: string
    character_maximum_length: number
}

export class ClmModel {
    id: string
    ask_id: string
    tals: string
    val: string
    als: string
    whe: string
    grb: boolean
    orb: boolean
    srt: number
}